import React, { useEffect, useState } from "react";
import { MwButton } from "../ui";
import { useCurrent, usePost } from "../../hooks";
import CardHeadeWithActions from "../ui/CardHeadeWithActions";
import BasicInfoForm from "./forms/BasicInfoForm";
import ResponsiblesForm from "./forms/ResponsiblesForm";
import AddressForm from "./forms/AddressForm";
import AdvancedForm from "./forms/AdvancedForm";
import { langObjType, objLangTextHandler } from "../../utils/global";
import { useTranslation } from "react-i18next";
import { invalidateFetchCache } from "../../hooks/useFetch";

const CreateVendor = ({ onHide, onVendorCreated = () => {}, setMode }) => {
  const [t] = useTranslation("global");
  const { currentTenantId, currentCompanyId, currentBranchId, currentLangList, currentLangId } =
    useCurrent();
  const [errors, setErrors] = useState({});
  const [tabActive, setTabActive] = useState("TabOne");
  const { data: resultPost, postData } = usePost();

  const [fullname, setFullname] = useState(langObjType());
  const [vendorNo, setVendorNo] = useState("");
  const [groupSelected, setGroupSelected] = useState([]);
  const [mobileNo, setMobileNo] = useState("");
  const [phoneNo, setPhoneNo] = useState();
  const [email, setEmail] = useState("");
  const [notes, setNotes] = useState("");
  const [isActive, setIsActive] = useState(true);

  const [responsibles, setResponsibles] = useState([]);
  const [address, setAddress] = useState([]);

  const [accountNo, setAccountNo] = useState();
  const [vatNo, setVatNo] = useState();
  const [limitCredit, setLimitCredit] = useState();

  const formValidate = () => {
    let errorObj = {};

    if (!fullname[currentLangId]) {
      errorObj = {
        ...errorObj,
        [`fullname.${currentLangId}`]: t("vendors.nameRequired"),
      };
    }

    if (mobileNo && isNaN(mobileNo)) {
      errorObj.mobileNo = t("vendors.mobileMustBeNumber");
    }

    if (Object.keys(errorObj).length !== 0) {
      setErrors(errorObj);
      return true;
    }
    return false;
  };

  const saveHandler = () => {
    if (formValidate()) {
      return;
    }
    const _data = {
      fullname: objLangTextHandler(fullname),
      vendorNo,
      mobileNo,
      phoneNo,
      email,
      notes,
      limitCredit,
      accountNo,
      vatNo,
      vendorGroupsIds: groupSelected.map((el) => el.value),
      responsibles,
      vendorAddresses: address,
      isActive,
      tenantId: currentTenantId,
      companyId: currentCompanyId,
      branchId: currentBranchId,
    };

    postData(`${process.env.REACT_APP_VENDORS_API_SERVER_BASE_URL}/`, _data);
  };

  const cancelHandle = () => {
    onHide();
  };

  useEffect(() => {
    if (resultPost) {
      const vendorsListUrl =
        currentTenantId && currentCompanyId && currentBranchId
          ? `${process.env.REACT_APP_VENDORS_API_SERVER_BASE_URL}/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
          : null;
      invalidateFetchCache(vendorsListUrl);
      onHide ? cancelHandle() : setMode("List");
      onVendorCreated();
    }
  }, [
    resultPost,
    currentTenantId,
    currentCompanyId,
    currentBranchId,
    onHide,
    setMode,
    onVendorCreated,
  ]);

  return (
    <div className={`${onHide && "p-5"}`}>
      <CardHeadeWithActions title={t("vendors.addNewVendor")}>
        {onHide && (
          <MwButton inGroup={true} type="cancelBtn" onClick={cancelHandle}>
            {t("vendors.cancel")}
          </MwButton>
        )}
        <MwButton inGroup={true} type="cancelBtn" onClick={() => setMode("List")}>
          {t("vendors.manageVendors")}
        </MwButton>
        <MwButton actionType={`button`} inGroup={true} onClick={saveHandler} type="saveBtn">
          {t("vendors.save")}
        </MwButton>
      </CardHeadeWithActions>
      <form>
        <div className=" bg-slate-50 rounded-lg text-xs p-3 flex flex-col gap-1">
          <ul className="flex gap-3 items-centers">
            <li
              onClick={() => setTabActive("TabOne")}
              className={`cursor-default rounded px-2 py-1 hover:font-bold ${
                tabActive === "TabOne" ? "bg-indigo-100 font-bold" : "bg-slate-100"
              }`}
            >
              {t("vendors.basicInfo")}
            </li>
            <li
              onClick={() => setTabActive("TabTwo")}
              className={`cursor-default rounded px-2 py-1 hover:font-bold ${
                tabActive === "TabTwo" ? "bg-indigo-100 font-bold" : "bg-slate-100"
              }`}
            >
              {t("vendors.responsibleData")}
            </li>
            <li
              onClick={() => setTabActive("TabThree")}
              className={`cursor-default rounded px-2 py-1 hover:font-bold ${
                tabActive === "TabThree" ? "bg-indigo-100 font-bold" : "bg-slate-100"
              }`}
            >
              {t("vendors.addresses")}
            </li>
            <li
              onClick={() => setTabActive("TabFour")}
              className={`cursor-default rounded px-2 py-1 hover:font-bold ${
                tabActive === "TabFour" ? "bg-indigo-100 font-bold" : "bg-slate-100"
              }`}
            >
              {t("vendors.advancedData")}
            </li>
          </ul>
          {tabActive === "TabOne" && (
            <BasicInfoForm
              currentTenantId={currentTenantId}
              currentCompanyId={currentCompanyId}
              currentBranchId={currentBranchId}
              currentLangId={currentLangId}
              currentLangList={currentLangList}
              errors={errors}
              vendorNo={vendorNo}
              setVendorNo={setVendorNo}
              groupSelected={groupSelected}
              setGroupSelected={setGroupSelected}
              fullname={fullname}
              setFullname={setFullname}
              mobileNo={mobileNo}
              setMobileNo={setMobileNo}
              phoneNo={phoneNo}
              setPhoneNo={setPhoneNo}
              email={email}
              setEmail={setEmail}
              notes={notes}
              setNotes={setNotes}
              isActive={isActive}
              setIsActive={setIsActive}
            />
          )}
          {tabActive === "TabTwo" && (
            <ResponsiblesForm
              currentLangId={currentLangId}
              currentLangList={currentLangList}
              errors={errors}
              responsibles={responsibles}
              setResponsibles={setResponsibles}
            />
          )}
          {tabActive === "TabThree" && (
            <AddressForm errors={errors} address={address} setAddress={setAddress} />
          )}
          {tabActive === "TabFour" && (
            <AdvancedForm
              errors={errors}
              accountNo={accountNo}
              setAccountNo={setAccountNo}
              vatNo={vatNo}
              setVatNo={setVatNo}
              limitCredit={limitCredit}
              setLimitCredit={setLimitCredit}
            />
          )}
        </div>
      </form>
    </div>
  );
};

export default CreateVendor;
